export const FREE_TEXT_INPUT_CONTAINER_SELECTOR = ".free-text-input-container"
export const FREE_TEXT_INPUT_CONTAINER_CONTENT_SELECTOR = ".free-text-input-container__content"
export const FREE_TEXT_INPUT_CONTAINER_CONTENT_BUTTONS_SELECTOR = ".free-text-input-container__content__buttons"
export const CHIP_CONTAINER_SELECTOR = ".chip-container"
export const WL_TEXT_INPUT_ELEMENT = "wl-text-input.free-text-input"
export const FREE_TEXT_INPUT_FILTER_NUMBER_SELECTOR = ".free-text-input.filter-number"
export const DISPLAYED_CSS_CLASS = "displayed"
export const FILTER_NUMBER_CSS_CLASS = "filter-number--hidden"